const styles = theme => ({
  main: {
    padding: '0',
  },
  container: {
    maxWidth: '1184px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
  Title: {
    fontWeight: '600',
    marginBottom: '16px',
    fontSize: '16px',
  },
  headsubtitle: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  breadcrumbsHolder: {
    padding: '0 0 30px',
    display: 'flex',
    alignItems: 'center',
    '& $serviceid': {
      marginLeft: 'auto',
    },
  },
  serviceid: {},
  breadcrumbs: {
    fontSize: '12px',
    '& li': {
      padding: '0',
      border: '0',
    },
    '& a': {
      color: '#1C999B',
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
      },
    },
    '& $activelink': {
      color: '#8C9099',
    },
  },
  activelink: {},
  mobiletitlehead: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px',
    borderBottom: '3px solid #EBEEF3',
    marginBottom: '16px',
    '& img': {
      marginRight: '13px',
      display: 'inline-block',
      flexShrink: '0',
    },
    '& h2': {
      fontSize: '16px',
      fontWeight: '500',
    },
  },
  mainTCcontent: {
    fontSize: '14px',
    lineHeight: '1.5',
  },
  tcFirstOrderList: {
    paddingLeft: '16px',
    '& > li': {
      marginBottom: '16px',
      '&::marker': {
        fontWeight: '600',
      },
    },
    '& ol': {
      paddingLeft: '5px',
      '& li': {
        marginBottom: '16px',
      },
    },
  },
  tableOfContentsFrame: {
    padding: '0 16px',
    // --wbkitPosition: '-webkit-sticky',
    position: 'sticky',
    '& h2': {
      fontWeight: '500',
    },
    '& ol': {
      padding: '0 0 0 16px',
      '& > li': {
        marginBottom: '8px',
        '&::marker': {
          fontWeight: '500',
          color: '#1C999B',
          fontSize: '14px',
        },
      },
      '& a': {
        color: '#1C999B',
        fontSize: '12px',
        fontWeight: '500',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    main: {
      padding: '26px 0',
    },
    Title: {
      fontSize: '24px',
      marginBottom: '35px',
    },
    headsubtitle: {
      fontSize: '16px',
    },
    mainTCcontent: {
      flexDirection: 'row-reverse',
    },
    tableOfContentsFrame: {
      background: '#fff',
      boxShadow: '1px 2px 12px rgba(0, 0, 0, 0.1)',
      borderRadius: '20px',
      padding: '16px 24px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    mainTCcontent: {
      padding: '0 15px',
    },
  },
});

export default styles;
